import { render, staticRenderFns } from "./TabPicture.vue?vue&type=template&id=4c77722d"
import script from "./TabPicture.vue?vue&type=script&lang=ts"
export * from "./TabPicture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports